/**
 * @file       Auth base URL resolver (Phase 9c dual-run)
 * @desc       Prefer environment.authUrl; fall back to apiUrl.
 */

import { environment } from '@environments/environment';

/**
 * @classdesc Resolve the cypher-auth base URL for issue paths.
 */
class AuthBaseUrl
{
    /**
     * @desc   - Auth host for login/SSO/refresh/logout
     * @access - public
     * @param  - -
     * @return - string base URL without trailing slash
     */
    static resolve()
    {
        let result;
        let authUrl;
        let apiUrl;
        let trimmed;

        apiUrl = String(environment.apiUrl || '');
        authUrl = (environment as { authUrl?: string }).
            authUrl;
        trimmed = authUrl == null ?
            '' :
            String(authUrl).trim();

        if (trimmed)
        {
            result = trimmed.replace(/\/+$/, '');
        }
        else
        {
            result = apiUrl.replace(/\/+$/, '');
        }

        return result;
    }
}

export { AuthBaseUrl };
